import React from 'react';

const PemberdayaanPemudaDesaDigital: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Keberhasilan jangka panjang dari sebuah program digitalisasi desa tidak ditentukan oleh kecanggihan teknologi saat peluncuran awal, melainkan oleh kesiapan masyarakat lokal dalam mengelola dan memanfaatkan sistem tersebut secara mandiri.
      </p>

      <p className="mb-4">
        Dalam program <b>Winner&apos;s Village Implementation Program (VIP)</b> pada ajang <i>Indonesia Innovative Technology (IIT) Challenge</i>, tim pemenang diterjunkan langsung ke Desa Marga Mulya untuk melakukan pendampingan intensif selama tiga hari kepada kelompok pemuda Karang Taruna dan perangkat desa.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Tahapan Alih Pengetahuan di Lapangan
      </h2>
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">📢 Hari 1: Sosialisasi</h3>
          <p className="text-sm text-gray-600">Mengenalkan tujuan platform, fitur utama, dan manfaat website bagi transparansi dan pariwisata desa kepada warga.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">💻 Hari 2: Pelatihan CMS</h3>
          <p className="text-sm text-gray-600">Praktik langsung pengelolaan konten, pembaruan data statistik kependudukan, dan unggah foto produk UMKM lokal.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🤝 Hari 3: Serah Terima</h3>
          <p className="text-sm text-gray-600">Simulasi penanganan kendala teknis dasar, evaluasi mandiri, dan penyerahan akun administrator resmi kepada desa.</p>
        </div>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Membangun Generasi Penggerak Desa
      </h2>
      <p className="mb-4">
        Melalui pelatihan ini, pemuda desa dilatih tidak hanya sebagai operator entri data, melainkan sebagai jurnalis warga dan kurator konten yang aktif menceritakan potensi desa mereka ke panggung digital yang lebih luas.
      </p>

      <p className="mb-4">
        Sinergi antara mahasiswa pengembang web dan komunitas lokal ini membuktikan bahwa teknologi hadir sebagai jembatan kemanusiaan yang memberdayakan masyarakat dari akar rumput.
      </p>
    </div>
  );
};

export default PemberdayaanPemudaDesaDigital;
